// elected officials translation keys
const CITY_COUNCIL = "local_council";
const CITY_COUNCIL_AT_LARGE = "local_council_at_large";
const COUNTY_COMMITTEE_AT_LARGE = "local_county_at_large";
const COUNTY_EXECUTIVE = "local_county_executive";
const COUNTY_OFFICIAL = "local_county";
const STATE_GOVERNOR = "state_gov";
const LOCAL_EXECUTIVE = "local_mayor_executive";
const MAYOR = "local_mayor";
const PRESIDENT = "fed_executive";
const VICE_PRESIDENT = "fed_executive_vice_president";
const STATE_EXECUTIVE = "state_gov_executive";
const STATE_HOUSE = "state_house";
const STATE_SENATE = "state_senate";
const US_HOUSE = "fed_house";
const US_SENATE = "fed_senate";

// candidate translation keys
const ATTORNEY_GENERAL = "attorney-general";
const GOVERNOR = "governor";
const INSURANCE_AND_SAFETY_FIRE_COMMISSIONER =
  "insurance-and-safety-fire-commissioner";
const LIEUTENANT_GOVERNOR = "lt-governor";
const THE_PRESIDENT = "the-president";
const SECRETARY_OF_STATE = "secretary-of-state";
const STATE_ASSEMBLYMEMBER = "state-assemblymember";
const STATE_AUDITOR = "state-auditor";
const STATE_CONTROLLER = "state-controller";
const STATE_COUNCILMEMBER = "state-councilmember";
const STATE_DELEGATE = "state-delegate";
const STATE_REPRESENTATIVE = "state-representative";
const STATE_SENATOR = "state-senator";
const STATE_TREASURER = "state-treasurer";
const TREASURER = "treasurer";
const US_REPRESENTATIVE = "us-representative";
const US_SENATOR = "us-senator";
const THE_VICE_PRESIDENT = "the-vice-president";
const SUPERINTENDENT_OF_PUBLIC_INSTRUCTION =
  "superintendent-of-public-instruction";
const STATE_MINE_INSPECTOR = "state-mine-inspector";

const ALL_RACES_IN_ORDER = [
  PRESIDENT,
  THE_PRESIDENT,
  VICE_PRESIDENT,
  THE_VICE_PRESIDENT,
  US_SENATE,
  US_SENATOR,
  US_HOUSE,
  US_REPRESENTATIVE,
  STATE_GOVERNOR,
  GOVERNOR,
  LIEUTENANT_GOVERNOR,
  ATTORNEY_GENERAL,
  INSURANCE_AND_SAFETY_FIRE_COMMISSIONER,
  STATE_EXECUTIVE,
  SECRETARY_OF_STATE,
  STATE_AUDITOR,
  STATE_CONTROLLER,
  STATE_TREASURER,
  TREASURER,
  STATE_SENATE,
  STATE_SENATOR,
  STATE_COUNCILMEMBER,
  STATE_ASSEMBLYMEMBER,
  STATE_DELEGATE,
  STATE_HOUSE,
  STATE_REPRESENTATIVE,
  COUNTY_EXECUTIVE,
  COUNTY_OFFICIAL,
  COUNTY_COMMITTEE_AT_LARGE,
  MAYOR,
  LOCAL_EXECUTIVE,
  CITY_COUNCIL,
  CITY_COUNCIL_AT_LARGE,
  SUPERINTENDENT_OF_PUBLIC_INSTRUCTION,
  STATE_MINE_INSPECTOR
];

export default {
  ALL_RACES_IN_ORDER,
  ATTORNEY_GENERAL,
  CITY_COUNCIL,
  CITY_COUNCIL_AT_LARGE,
  COUNTY_COMMITTEE_AT_LARGE,
  COUNTY_EXECUTIVE,
  COUNTY_OFFICIAL,
  GOVERNOR,
  INSURANCE_AND_SAFETY_FIRE_COMMISSIONER,
  LIEUTENANT_GOVERNOR,
  LOCAL_EXECUTIVE,
  MAYOR,
  PRESIDENT,
  SECRETARY_OF_STATE,
  STATE_ASSEMBLYMEMBER,
  STATE_AUDITOR,
  STATE_CONTROLLER,
  STATE_COUNCILMEMBER,
  STATE_DELEGATE,
  STATE_EXECUTIVE,
  STATE_GOVERNOR,
  STATE_HOUSE,
  STATE_MINE_INSPECTOR,
  STATE_REPRESENTATIVE,
  STATE_SENATE,
  STATE_SENATOR,
  STATE_TREASURER,
  SUPERINTENDENT_OF_PUBLIC_INSTRUCTION,
  THE_PRESIDENT,
  THE_VICE_PRESIDENT,
  TREASURER,
  US_HOUSE,
  US_REPRESENTATIVE,
  US_SENATE,
  US_SENATOR,
  VICE_PRESIDENT
};
